import { render } from "./reprint.vue?vue&type=template&id=b1255d44"
import script from "./reprint.vue?vue&type=script&lang=js"
export * from "./reprint.vue?vue&type=script&lang=js"

import "./reprint.vue?vue&type=style&index=0&id=b1255d44&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__